import { AcadBaseDocument } from "@framework/models";

export default class ScholarshipEligibility extends AcadBaseDocument {
  static readonly PATH: string = "scholarshipEligibilities";
  id: string = "";
  name: string = "";
}
